import styled from 'styled-components';

export const InformationParagraph = styled.p`
  margin: 0.25rem 0;
`;
